import CircularProgress from '@cp/src/components/ProgressBars/circularProgress/CircularProgress';
import styles from './index.module.scss';
import AlertIcon from '@cp/src/assets/icons/AlertIcon';
import { IDaysTillEscalation } from '../../types';
import cx from 'classnames';

const DaysTillEscalation = (props: IDaysTillEscalation) => {
  const {
    daysTillEscalation,
    progressPercent,
    progressTextClass,
    containerClass,
    sqSize = 40,
    strokeWidth = 6
  } = props;
  return (
    <div className={cx('relative w-10 h-10', containerClass)}>
      <CircularProgress
        circleProgress={styles.orange}
        circleBackground={styles.lightOrange}
        sqSize={sqSize}
        strokeWidth={strokeWidth}
        withAnimation={true}
        percentage={progressPercent < 0 ? 0 : progressPercent}
        defaultCircleOffsets={{ dashArray: 180, dashOffset: 180 }}
      />
      <span className={cx(styles.progressText, progressTextClass)}>
        {daysTillEscalation > 0 ? (
          daysTillEscalation
        ) : (
          <AlertIcon fillColor="var(--navi-color-orange-base)" />
        )}
      </span>
    </div>
  );
};

export default DaysTillEscalation;
